export type RakutenRegion = 'mx' | 'eu' | null;
export type AmazonRegion = 'us' | 'es' | 'mx' | 'intl';

export const EU_COUNTRY_CODES = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
] as const;

const EU_COUNTRY_SET = new Set<string>(EU_COUNTRY_CODES);

export function normalizeCountryCode(countryCode?: string | null): string | null {
  if (!countryCode) {
    return null;
  }

  const normalized = countryCode.trim().toUpperCase();
  return normalized.length === 2 ? normalized : null;
}

export function getRakutenRegion(countryCode?: string | null): RakutenRegion {
  const normalized = normalizeCountryCode(countryCode);

  if (normalized === 'MX') {
    return 'mx';
  }

  if (normalized && EU_COUNTRY_SET.has(normalized)) {
    return 'eu';
  }

  return null;
}

export function getAmazonRegion(countryCode?: string | null): AmazonRegion {
  const normalized = normalizeCountryCode(countryCode);

  if (normalized === 'US') {
    return 'us';
  }

  if (normalized === 'ES') {
    return 'es';
  }

  if (normalized === 'MX') {
    return 'mx';
  }

  return 'intl';
}

export function getCountryCodeFromLocale(locale?: string | null): string | null {
  if (!locale) {
    return null;
  }

  const localeParts = locale.split('-');
  return normalizeCountryCode(localeParts[1]);
}
